import { i18n } from "../i18n/i18n";

import React, { Component, forwardRef, ForwardedRef } from 'react'
import dateUtil from '../utils/date.util'
import DatePicker from './DatePicker/DatePicker'
import Button from './Button'

type RangeExportDate = 'start' | 'end'
type RangeExportDateState = Record<RangeExportDate, string>

interface RangeExportProps {
  onExport: (start: string, end: string) => void
  onFilter?: (start: string, end: string) => void
}

interface RangeExportState extends RangeExportDateState {}

class RangeExport extends Component<RangeExportProps, RangeExportState> {
  constructor (props: RangeExportProps) {
    super(props)
    const defaultDate = dateUtil.now()
    this.state = {
      start: props.onFilter ? '' : defaultDate,
      end: props.onFilter ? '' : defaultDate
    }
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleExportClick = this.handleExportClick.bind(this)
    this.handleFilterClick = this.handleFilterClick.bind(this)
    this.reset = this.reset.bind(this)
  }

  reset () {
    this.setState({
      start: '',
      end: ''
    })
  }

  get filterButton () {
    return this.props.onFilter && (
      <Button
        text={i18n("Filter")}
        onClick={this.handleFilterClick} />
    )
  }

  handleDateChange (name: string, date: string) {
    if (name === 'start') this.setState({ start: date })
    if (name === 'end') this.setState({ end: date })
  }

  handleExportClick () {
    const { start, end } = this.state
    this.props.onExport(start, end)
  }

  handleFilterClick () {
    const { onFilter } = this.props
    const { start, end } = this.state
    onFilter && onFilter(start, end)
  }

  render () {
    return (
      <div className="flex flex-col md:flex-row gap-5 w-full md:w-auto">
        <DatePicker
          className="mb-0"
          name="start"
          value={this.state.start}
          label={i18n("Start")}
          onChange={this.handleDateChange} />
        <DatePicker
          className="mb-0"
          name="end"
          value={this.state.end}
          label={i18n("End")}
          onChange={this.handleDateChange} />
        <div className="md:self-end flex gap-5">
          {this.filterButton}
          <Button
            text={i18n("Export")}
            onClick={this.handleExportClick} />
        </div>
      </div>
    )
  }
}

const ForwardedRangeExport = forwardRef((props: RangeExportProps, ref: ForwardedRef<{ reset: () => void }>) => {
  const componentRef = React.useRef<RangeExport>(null)

  React.useImperativeHandle(ref, () => ({
    reset: () => {
      if (componentRef.current) {
        componentRef.current.reset()
      }
    }
  }))

  return <RangeExport {...props} ref={componentRef} />
})

ForwardedRangeExport.displayName = 'RangeExport'

export default ForwardedRangeExport
